var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTrendArrow = function SvgTrendArrow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 3.33594C12.1768 3.33594 12.3464 3.40618 12.4714 3.5312C12.5964 3.65622 12.6667 3.82579 12.6667 4.0026V9.33594C12.6667 9.51275 12.5964 9.68232 12.4714 9.80734C12.3464 9.93237 12.1768 10.0026 12 10.0026C11.8232 10.0026 11.6536 9.93237 11.5286 9.80734C11.4036 9.68232 11.3333 9.51275 11.3333 9.33594V5.61194L4.7 12.2453C4.57426 12.3667 4.40586 12.4339 4.23106 12.4324C4.05627 12.4309 3.88906 12.3608 3.76545 12.2372C3.64185 12.1135 3.57173 11.9463 3.57022 11.7715C3.5687 11.5967 3.63589 11.4283 3.75733 11.3026L10.3907 4.66927H6.66666C6.57912 4.66927 6.49243 4.65203 6.41154 4.61852C6.33066 4.58502 6.25717 4.53591 6.19526 4.47401C6.13335 4.4121 6.08425 4.33861 6.05075 4.25773C6.01724 4.17684 6 4.09015 6 4.0026C6 3.91506 6.01724 3.82837 6.05075 3.74748C6.08425 3.6666 6.13335 3.59311 6.19526 3.5312C6.25717 3.46929 6.33066 3.42019 6.41154 3.38668C6.49243 3.35318 6.57912 3.33594 6.66666 3.33594H12Z",
    fill: "#148B07"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTrendArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trend-arrow.cbf8d5817f623f9f4c30cf86af6cd4dc.svg";